import { useEffect, useMemo, useRef, useState } from "react";

import * as Material from "@mui/material";

import BottomSubmit from "../../components/BottomSubmit";
import ConfigLoader from "../../components/ConfigLoader";


import './styles.css'

import api from '@helpers/api'

import { Input, Text, Button } from '@fragments'

import { IconArrowFork, IconPlus, IconTrash } from "@tabler/icons-react";

import { useCommunity } from "contexts/community";

import { useParams } from "react-router-dom";

import ManageCouponModal from "@modals/Billing/ManageCouponModal";
import UsersModal from "@components/Modals/UsersModal/index.js";


import { UserAvatar } from "@components/Community";


export default function Split({ info }) {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState();
    const [hasUpdates, setHasUpdates] = useState(false)


    let { slug } = useParams();

    const { loading: communityLoading, community } = useCommunity();

    const REF_userSelect = useRef()
    const REF_configCouponModal = useRef()


    useEffect(() => {
        if (!communityLoading) handleLoad()
    }, [communityLoading])

    const currentCommunity = community.getBySlug(slug)

    async function handleLoad() {
        setLoading(true)
        try {
            const { data } = await api.get('split?community=' + currentCommunity.id)
            setData([...data.config.customer])
        } catch (e) {
            console.log(e)
        }
        setLoading(false)
    }


    function handleUserSelected(user) {
        if (!user.has_wallet) {
            setError('O usuário "' + user.username + '" deve cadastrar uma conta bancária para receber splits')
            return
        }
        if (data?.filter(u => u.id === user.id)[0]) {
            setError('Este usuário já foi selecionado')
            return
        }

        setData([...data, {
            ...user,
            percentile: 0
        }])

        setHasUpdates(true)

    }

    function handleInput(value, user) {
        const dataCopy = [...data].map(receiver => {
            if (receiver.id == user.id) {
                receiver.percentile = parseInt(value)
            }
            return receiver
        })
        console.log(dataCopy)
        setData([...dataCopy])
        setHasUpdates(true)

    }

    function handleRemoveReceiver(user) {
        const dataCopy = [...data].filter(u => u.id !== user.id)
        setData([...dataCopy])
        setHasUpdates(true)
    }

    async function handleSubmit() {
        try {
            const valid = isValid();

            if (!valid) {
                return;
            }

            const response = await api.post("split", {
                community: currentCommunity.id,
                config: data.map(v => {
                    return {
                        user: v.id,
                        percentile: parseInt(v.percentile)
                    }
                })
            });

            if (!response.data.id) {
                setError("Um erro ocorreu ao salvar as regras de split");
            } else {
                window.setSnackbar('Regras de split salvas com sucesso')
                setHasUpdates(false)
            }
        } catch (e) {
            setError("Houve um erro ao salvar as regras de split");
            console.log(e);
        }

        function isValid() {
            const allValuesValid = [...data].filter(v => (v.percentile <= 0) || (v.percentile > 100)).length === 0
            if (!allValuesValid) {
                setError('Insira um percentual entre 0 e 100')
                return
            }

            const sum = [...data].reduce((n, { percentile }) => n + percentile, 0)

            if (sum !== 100) {
                setError('A soma dos valores de split deve ser igual a 100')
                return
            }

            return true
        }
    }

    function handleAddReceiver() {
        REF_userSelect.current.open(
            currentCommunity.id,
            handleUserSelected
        )
    }

    function ErrorMessage() {
        useEffect(() => {
            if (error) {
                setTimeout(() => {
                    setError(null)
                }, 4000)
            }
        }, [error])
        return (
            <>
                {error && (
                    <Material.Alert className="mt-2 error-form-split" severity="error">
                        {error}
                    </Material.Alert>
                )}
            </>
        )
    }


    const MEMO_bottomControl = useMemo(() => <BottomSubmit onPress={handleSubmit} key={hasUpdates} />, [hasUpdates])


    return (
        <div className="config-page config-general-community" key={loading}>
            {(loading || communityLoading) ? <ConfigLoader /> : (
                <div className="mt-8">
                    <Text.h3
                        grow
                        left={<IconArrowFork />}
                        right={<Button
                            text="Adicionar recebedor"
                            tooltip="Adicione um novo recebedor"
                            endIcon={<IconPlus />}
                            onClick={handleAddReceiver}
                        />}
                        value="Configuração de split"
                        className="mb-2"
                    />
                    <Text.h4
                        value="Divida a receita das vendas do produto entre diferentes recebedores"
                        contrast={5}
                        className="mb-2"
                    />

                    <div className="mt-4">
                        {data?.map((user, i) => (
                            <div key={i} className="my-1 receiver-split-row">
                                <div className="split-user-block">
                                    <UserAvatar user={user} displayName={true} size={34} />
                                </div>
                                <Input.Integer
                                    variant="dark"
                                    value={user.percentile}
                                    onInput={(v) => handleInput(v, user)}
                                    placeholder="Insira um percentual"
                                    max={100}
                                    style={{ maxWidth: '150px' }}
                                    end={'%'}
                                />
                                <Button
                                    color="overlay"
                                    icon={<IconTrash />}
                                    tooltip="Remover recebedor"
                                    onClick={() => handleRemoveReceiver(user)} rounded={true}
                                />
                            </div>
                        ))}
                    </div>

                    <ErrorMessage />
                </div>
            )}

            {hasUpdates ? MEMO_bottomControl : null}

            <UsersModal modalRef={REF_userSelect} />

            <ManageCouponModal modalRef={REF_configCouponModal} />
        </div >
    )
}

/*
function SplitConfigModal({ modalRef }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [error, setError] = useState();

    const [data, setData] = useState([])

    const REF_config = useRef({});
    const REF_callback = useRef();

    const REF_userSelect = useRef()

    modalRef.current = {
        open(communityId, callback = () => { }) {
            REF_config.current = { community: communityId };
            REF_callback.current = callback;
            setData([])
            setError(null);
            setOpen(true);
        },
    };



    async function loadSplitRules() {
        setLoading(true)
        try {
            console.log(REF_config.current)
            const { data } = await api.get('split?community=' + REF_config.current.community)
            setData([...data.config.customer])
        } catch (e) {
            console.log(e)
        }
        setLoading(false)
    }

    return (
        <>

            <CustomModal
                maxWidth={480}
                bottomButtonCancelText="Cancelar"
                loading={loading}
                title="Configurar regras de split"
                open={open}
                handleSubmit={handleSubmit}
                bottomButtonSumbitText="Salvar configuração"
                handleClose={() => setOpen(false)}
                bodyComponent={
                    open ? (
                        <div className="px-4 pt-4">

                        </div>
                    ) : null
                }
            />
        </>
    );
}*/